import { GameMode } from '../types';
import type { ModeDescription } from './types';

export const ROLLING_FIVE_MODE: ModeDescription = {
  mode: GameMode.ROLLING_FIVE,
  title: 'Rolling Five',
  description: 'Infinite five-question gauntlet with recovery tokens.',
  icon: '♻️',
};
